/* istanbul ignore file */
import { IPRangeMixin } from './IPRangeMixin';
const AssignmentIPRangeParser = /* #__PURE__ */ IPRangeMixin;
export class AssignmentIPRange extends IPRangeMixin {
    static decode(input) {
        return AssignmentIPRangeParser.decode(input).map(res => new AssignmentIPRange(res));
    }
    static unsafeDecode(input) {
        return AssignmentIPRange.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentIPRangeParser.encode(data);
    }
    static schema() {
        return AssignmentIPRangeParser.schema();
    }
}
